"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapUrlRecommendationToRecommendationDetails = exports.mapProductDetailsToRecommendationDetails = void 0;
function mapProductDetailsToRecommendationDetails(productDetails) {
    return {
        advertiser_id: productDetails.advertiser_id,
        currency: productDetails.currency,
        is_available: productDetails.is_available,
        merchant_name: productDetails.merchant_name,
        price: productDetails.price,
        urls: {
            affiliated_url: productDetails.urls.affiliated_url,
        },
        original_price: productDetails.original_price, //we need to check this
        description: productDetails.description,
        product_images: productDetails.product_images,
        product_name: productDetails.product_name,
        product_brand: productDetails.product_brand,
        sku: productDetails.sku,
        score: productDetails.ecpc,
    };
}
exports.mapProductDetailsToRecommendationDetails = mapProductDetailsToRecommendationDetails;
function mapUrlRecommendationToRecommendationDetails(urlRecommendation) {
    return {
        advertiser_id: urlRecommendation.merchant_id ?? null,
        currency: urlRecommendation.currency,
        is_available: isAvailable(urlRecommendation.stock),
        merchant_name: urlRecommendation.merchant_name,
        price: urlRecommendation.price,
        urls: {
            affiliated_url: urlRecommendation.affiliated_url,
        },
        original_price: 0, //we need to check this
        description: urlRecommendation.product_description,
        product_images: urlRecommendation.product_image_url,
        product_name: urlRecommendation.product_title,
        product_brand: urlRecommendation.product_brand,
        sku: null,
        score: urlRecommendation.score,
    };
}
exports.mapUrlRecommendationToRecommendationDetails = mapUrlRecommendationToRecommendationDetails;
function isAvailable(stockInteger) {
    return stockInteger > 0;
}
